import { Injectable, inject } from '@angular/core';
import { Environment } from '../domain/environment.model';
import { RmaApiUrlType } from './rma-api-url/rma-api-type.const';

@Injectable({ providedIn: 'root' })
export class RmaUrlsService {
  private readonly environment = inject(Environment);

  apiUrl(value: string, apiType: RmaApiUrlType = 'Rma'): string {
    const cleanedPath = this.stripLeadingSlash(value);
    return this.formatUrl(cleanedPath, this.getApiUrl(apiType));
  }

  public baseUrl(value: string): string {
    const cleanedPath = this.stripLeadingSlash(value);
    return this.formatUrl(cleanedPath, this.environment.baseUrl);
  }

  public cdnUrl(value: string): string {
    return this.formatUrl(value, this.environment.assets.cdnUrl);
  }

  public illustrationUrl(value: string): string {
    return this.imageUrl(`illustrations/${this.stripLeadingSlash(value)}`);
  }

  public imageUrl(value: string): string {
    return this.staticAssetUrl(`/assets/images/${this.stripLeadingSlash(value)}`);
  }

  public staticAssetUrl(value: string): string {
    return this.formatUrl(value, this.environment.assets.staticUrl);
  }

  private formatUrl(value: string, host: string) {
    const url = new URL(value, host);
    return url.toString();
  }

  private stripLeadingSlash(value: string) {
    if (!value) {
      return value;
    }

    return value.replace(/^\//, '');
  }

  private getApiUrl(apiType: RmaApiUrlType) {
    const { reviewsApiUrl, socialApiUrl, billingApiUrl, surveyApiUrl, emailApiUrl, findMyAgentApiUrl, apiUrl } = this.environment.api;

    switch (apiType) {
      case 'Reviews':
        return reviewsApiUrl;
      case 'Social':
        return socialApiUrl;
      case 'Billing':
        return billingApiUrl;
      case 'Survey':
        return surveyApiUrl;
      case 'Email':
        return emailApiUrl;
      case 'FindMyAgent':
        return findMyAgentApiUrl;
      case 'Rma':
      default:
        return apiUrl;
    }
  }
}
